import Vue from 'vue';
import moment from 'moment';
import postEditor from '../../../components/post-editor.vue';
import loadModal from '../../../components/load-modal.vue';

export default () => {
  const view = document.querySelector('.posts-edit');
  const post = $(view).data('post');
  const creators = $(view).data('creators');

  new Vue({
    el: '.posts-edit',
    data: {
      canUnload: false,
      lastSavedAt: null,
      creators: creators,
      redirect_to: post.redirect_to,
    },
    components: {
      'post-editor': postEditor,
      'load-modal': loadModal,
    },
    mounted() {
      const editor = this.$refs.editor;
      editor.title = post.title;
      editor.comment = post.comment;
      editor.body = post.resolved_body;
      editor.co_writer_ids = post.co_writer_ids;
      editor.thumbnail_url = post.thumbnail;
      editor.thumbnail_quote_url = post.thumbnail_quote_url;
      editor.tags = post.tags;
      editor.goalKeywords = post.goal_keywords.split(',');
      editor.suggestKeywords = post.suggest_keywords.split(',');
      editor.creator_id = post.creator_id;
      const creator = this.creators.find((c) => c.id === editor.creator_id);
      editor.creator = creator
        ? { name: `${creator.title} ${creator.name}`, id: creator.id }
        : null;
      editor.split = !post.nosplit;
      editor.version = post.version;
      window.onbeforeunload = (e) => {
        if (!this.canUnload) {
          return '変更が保存されない可能性があります。';
        }
      };
      bus.$on('editorInitialized', () => {
        this.canUnload = true;
      });
      bus.$on('editorUpdated', () => {
        this.canUnload = false;
      });
      // setInterval(this.autoSave, 1000*20);
    },
    computed: {
      previewURL() {
        return `/admins/posts/${post.id}/preview`;
      },
    },
    methods: {
      moment,
      onScrollTop() {},
      getBodyJSON() {
        const editor = this.$refs.editor;
        return editor.bodyJSON;
      },
      async autoSave() {
        const editor = this.$refs.editor;

        try {
          const response = await this.savePost('autosave');
          editor.version = response.version;
          this.lastSavedAt = new Date();
          setTimeout(() => {
            this.lastSavedAt = null;
          }, 3000);
        } catch (e) {
          loadModal.loading = false;
          loadModal.error = true;
          if (e.responseJSON) {
            loadModal.message = e.responseJSON.message;
          }
          setTimeout(() => {
            loadModal.error = false;
          }, 3000);
        }
      },
      async savePost(context = null) {
        const editor = this.$refs.editor;
        const data = {
          title: editor.title,
          comment: editor.comment,
          body: this.getBodyJSON(),
          co_writer_ids: editor.co_writer_ids,
          thumbnail: editor.thumbnail_url,
          thumbnail_quote_url: editor.thumbnail_quote_url,
          tag_ids: editor.tagIds,
          creator_id: editor.creator_id,
          goal_keywords: editor.goalKeywords.join(','),
          suggest_keywords: editor.suggestKeywords.join(','),
          nosplit: !editor.split,
          version: editor.version,
          context: context,
        };

        return await $.ajax({
          url: `/admins/posts/${post.id}`,
          method: 'PATCH',
          contentType: 'application/json',
          dataType: 'json',
          data: JSON.stringify(data),
        });
      },
      async onSavePost() {
        this.canUnload = true;
        const editor = this.$refs.editor;
        const loadModal = this.$refs.loadModal;
        loadModal.loading = true;
        try {
          const response = await this.savePost('explicit');
          loadModal.loading = false;
          loadModal.success = true;
          editor.version = response.version;
          setTimeout(() => {
            loadModal.success = false;
          }, 1000);
        } catch (e) {
          loadModal.loading = false;
          loadModal.error = true;
          if (e.responseJSON) {
            loadModal.message = e.responseJSON.message;
          }
          setTimeout(() => {
            loadModal.error = false;
          }, 3000);
        }
      },
      async handleUpdateRedirectTo(e) {
        e.preventDefault();
        try {
          await $.ajax({
            url: `/admins/posts/${post.id}.json`,
            method: 'PATCH',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({
              redirect_to: this.redirect_to,
            }),
          });
          alert('更新しました');
        } catch (e) {
          alert('更新に失敗しました');
        }
      },
    },
  });
};
